import { ReactNode } from "react";
import { BasePanel } from "~/components/base-panel";
import { EmptyList } from "~/components/empty/empty-list";

export interface ErrorPanelProps {
  title: string;
  errorTitle: string;
  errorMessage: string;
  variant?: "error";
  buttons?: ReactNode[];
  classes?: {
    container?: string;
    title?: string;
  };
}

export const ErrorPanel = ({
  title,
  errorTitle,
  errorMessage,
  variant = "error",
  buttons,
  classes,
}: ErrorPanelProps) => {
  return (
    <BasePanel
      title={title}
      isEmpty
      emptyComponent={
        <EmptyList
          title={errorTitle}
          errorMessage={errorMessage}
          variant={variant}
          buttons={buttons}
          classes={classes}
        />
      }
    />
  );
};
